export enum ContactAttributeType {
  Text = 'text',
  Number = 'number',
  Decimal = 'decimal',
  Date = 'date',
}
